<template>
  <div class="absolute inset-0 flex items-center justify-center">
    <Container class="pointer-events-none relative z-20 flex h-full items-center text-white">
      <div class="w-full">
        <AnimatedText
          :copy="title"
          :visible="textVisible"
          tag="h2"
          class="max-w-4xl px-6 text-4xl leading-tight sm:justify-center md:text-5xl md:leading-tight lg:px-24 lg:text-6xl lg:leading-tight" />
      </div>
    </Container>
    <div
      class="absolute h-[120vw] w-[120vw] rounded-full blur-2xl duration-75"
      :class="[`bg-${color}`]"
      :style="{
        transform: `scale3d(${scale}, ${scale}, 1)`
      }" />
  </div>
</template>

<script setup lang="ts">
  import { ref, watch } from 'vue'

  import AnimatedText from './animated-text.vue'

  type gradientCircle = {
    color: string
    trigger: number
    title: string
  }

  const props = defineProps<gradientCircle>()

  const textVisible = ref(false)
  const scale = ref(0.2)

  watch(
    () => props.trigger,
    trigger => {
      if (trigger > 1 || trigger < 0) {
        textVisible.value = false
      } else {
        textVisible.value = true
      }
      scale.value = Math.min(1, Math.max(0.2, trigger + 0.15))
    }
  )
</script>
